import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-and-drop reordering of nodes within a Runbook::Definition's
// structured form editor table. Persists new order via PATCH to
// runbooks/:runbook_key/nodes/reorder. Modelled on
// album_image_sortable_controller.js (the cleanest minimal Sortable +
// Stimulus pairing in the codebase) -- NOT the DAG canvas editor, which is
// out of scope for this card.

export default class extends Controller {
  static targets = ["list"]
  static values = { url: String }

  connect() {
    if (!this.hasListTarget) return

    this._sortable = Sortable.create(this.listTarget, {
      handle: "[data-sort-handle]",
      animation: 150,
      ghostClass: "opacity-40",
      chosenClass: "sortable-chosen-ring",
      forceFallback: true,
      fallbackOnBody: false,
      swapThreshold: 0.65,
      onEnd: () => this._persistOrder()
    })
  }

  disconnect() {
    this._sortable?.destroy()
    this._sortable = null
  }

  _persistOrder() {
    const rows = this.listTarget.querySelectorAll("[data-node-id]")
    const nodeIds = Array.from(rows).map(el => el.dataset.nodeId).filter(Boolean)
    if (nodeIds.length === 0 || !this.hasUrlValue) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({ node_ids: nodeIds })
    })
  }
}
